import { combineReducers } from 'redux';
import loginReducer from '../reducer/login/loginReducer';
import sidebarReducer from '../reducer/sidebar/sidebarReducer';
import rawStockReducer from '../reducer/rawStock/rawStockReducer';
import rawStockCodeReducer from '../reducer/rawStockCode/rawStockCodeReducer';
import rawStockHistoryReducer from '../reducer/rawStockHistory/rawStockHistoryReducer';
import stoneReducer from '../reducer/stone/stoneReducer';
import stockReducer from '../reducer/stock/stockReducer';
import purityReducer from '../reducer/purity/purityReducer';
import colorReducer from '../reducer/color/colorReducer';
import importedInventoryReducer from '../reducer/importedInventory/importedInventoryReducer';
import departmentReducer from '../reducer/department/departmentReducer';
import employeeReducer from '../reducer/employee/employeeReducer';
import userReducer from '../reducer/user/userReducer';
import batchInventoryProcessReducer from '../reducer/batchInventoryProcess/batchInventoryProcessReducer';
import csvImportLogsReducer from '../reducer/csvImportLogs/csvImportLogsReducer';
import { departmentWisePendingReportReducer, departmentWiseProductionReportReducer } from '../reducer/reports/reportsReducer';
import stockIssueReducer from '../reducer/stockIssue/stockIssueReducer';
import stockReturnReducer from '../reducer/stockReturn/stockReturnReducer';
import rawStockReportReducer from '../reducer/rawStock/rawStockReportReducer';
import goldStockAddedReportReducer from '../reducer/reports/goldStockAddedReportReducer';
import stoneStockAddedReportReducer from '../reducer/reports/stoneStockAddedReportReducer';
import dashboardReducer from '../reducer/dashboard/dashboardReducer';
import roleMenuPermissionsReducer from '../reducer/roleMenuPermissionsReducer';
import activityLogReducer from '../reducer/activityLog/activityLogReducer';


const rootReducer = combineReducers({
  login: loginReducer,
  sidebar: sidebarReducer,
  rawStock: rawStockReducer,
  rawStockCode: rawStockCodeReducer,
  rawStockHistory: rawStockHistoryReducer,
  stone: stoneReducer,
  stock: stockReducer,
  purity: purityReducer,
  color: colorReducer,
  importedInventory: importedInventoryReducer,
  department: departmentReducer,
  employee: employeeReducer,
  user: userReducer,
  batchInventoryProcess: batchInventoryProcessReducer,
  csvImportLogs: csvImportLogsReducer,
  departmentWisePendingReport: departmentWisePendingReportReducer,
  departmentWiseProductionReport: departmentWiseProductionReportReducer,
  stockIssue: stockIssueReducer,
  stockReturn: stockReturnReducer,
  rawStockReport: rawStockReportReducer,
  goldStockAddedReport: goldStockAddedReportReducer,
  stoneStockAddedReport: stoneStockAddedReportReducer,
  dashboard: dashboardReducer,
  roleMenuPermissions: roleMenuPermissionsReducer,
  activityLog: activityLogReducer,
});

export default rootReducer; 